module.exports = __webpack_public_path__ + "img/MN.3cd042b6.png";